import { combineReducers } from 'redux';
import makeSelectedReducer from '../../../oldpantheon/redux/creators/reducers/makeSelectedReducer';

const selected = makeSelectedReducer({ model: `sign` });

export default combineReducers({ selected });
